




























import Vue, { PropType } from "vue";
import { Data, Methods, Computed, Props } from "./types";
import { SettingLabel } from "../../types";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import CheckBox from "@/components/Atoms/Forms/Checkbox/index.vue";
import { NotificationSetting } from "@/api/types";

const CATEGORY_LABELS = {
  competitorSettings: "企業情報",
  universitySettings: "大学情報"
};

const CATEGORY_DESCRIPTION = {
  competitorSettings: "フォローした大学の情報を通知します",
  universitySettings: "フォローした大学の情報を通知します"
};

type CheckBoxLabels = { [key in keyof NotificationSetting]: string };

const CHECKBOX_LABELS: CheckBoxLabels = {
  add_competitor_intern: "インターン情報の新着通知",
  update_competitor_intern: "インターン情報の更新通知",
  add_competitor_experience: "体験談の新着通知",
  add_target_university_schedule: "催事・テスト日程情報の新着通知",
  update_target_university_schedule: "催事・テスト日程情報の更新通知"
};

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "SettingTable",
  components: {
    Heading,
    CheckBox
  },
  props: {
    notificationSetting: {
      type: Object as PropType<Props["notificationSetting"]>,
      required: true
    }
  },
  data() {
    return {
      checkedSettingKeys: [],
      nextNotificationSetting: { ...this.notificationSetting }
    };
  },
  computed: {
    formattedNotificationSetting() {
      const {
        add_competitor_intern,
        update_competitor_intern,
        add_competitor_experience,
        add_target_university_schedule,
        update_target_university_schedule
      } = this.nextNotificationSetting;

      return {
        competitorSettings: {
          add_competitor_intern,
          update_competitor_intern,
          add_competitor_experience
        },
        universitySettings: {
          add_target_university_schedule,
          update_target_university_schedule
        }
      };
    }
  },
  watch: {
    checkedSettingKeys() {
      this.changeNotificationSetting();
    }
  },
  mounted() {
    this.initCheckedSettingKeys();
  },
  methods: {
    getCategoryLabel(key) {
      return CATEGORY_LABELS[key];
    },
    getCategoryDescription(key) {
      return CATEGORY_DESCRIPTION[key];
    },
    getCheckboxLabel(key) {
      return CHECKBOX_LABELS[key];
    },
    initCheckedSettingKeys() {
      // NOTE レスポンスデータをもとにチェックボックスの状態を初期化
      this.checkedSettingKeys = Object.entries(this.notificationSetting)
        // NOTE 受信許可済み(true)の項目を選択状態にする
        .filter(([_, val]: [string, boolean]) => val)
        .map(([key, _]) => key as SettingLabel);
    },
    changeNotificationSetting() {
      Object.keys(this.nextNotificationSetting).forEach(key => {
        // NOTE checkedSettingKeysに含まれているプロパティをtrueそれ以外をfalseにする
        if (this.checkedSettingKeys.includes(key as SettingLabel)) {
          this.nextNotificationSetting[key as SettingLabel] = true;
        } else {
          this.nextNotificationSetting[key as SettingLabel] = false;
        }
      });
      this.$emit("changeNotificationSetting", this.nextNotificationSetting);
    }
  }
});
